<template>
    <div>
        <div class="card my-3">
            <div class="card-header">
                反馈模板信息管理
            </div>
            <div class="card-body" style="min-height: 600px">
                <div v-if="surveyTemplateData.length===0" class="alert alert-warning">没有反馈模板，请添加</div>
                <table v-else class="table table-bordered table-striped">
                    <thead>
                    <tr>
                        <th class="text-center align-middle" style="width: 5%">序号</th>
                        <th class="text-center align-middle" style="width: 50%">名称</th>
                        <th class="text-center align-middle" style="width: 20%">所属类型</th>
                        <th class="text-center align-middle" style="width: 8%">状态</th>
                        <th class="text-center align-middle" style="width: 17%">详情</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(tmpl, index) in surveyTemplateData" :key="tmpl.surveyTemplateId">
                        <td class="text-center align-middle">{{index+1}}</td>
                        <td class="text-left align-middle">{{tmpl.surveyTemplateName}}</td>
                        <td class="text-center align-middle">{{tmpl.surveyTemplateTypeName}}</td>
                        <td class="text-center align-middle">{{tmpl.stateName}}</td>
                        <td class="text-center align-middle">
                            <button class="btn btn-primary btn-sm mr-2" v-if="tmpl.state===surveyTemplateState.V1_NON_PUBLISHED"
                                    @click="btnEditSurveyTemplateInfo_Click(index)">编辑</button>
                            <router-link :to="{name: 'AdminSurveyTemplateEdit', params: {surveyTemplateId: tmpl.surveyTemplateId}}"
                                         class="btn btn-info btn-sm mr-2" v-if="tmpl.state===surveyTemplateState.V1_NON_PUBLISHED"
                                         @click="btnEditSurveyTemplateInfo_Click(index)">项管理</router-link>
                            <button class="btn btn-info btn-sm mr-2" v-if="tmpl.state!==surveyTemplateState.V1_NON_PUBLISHED"
                                    @click="btnShowSurveyTemplateInfo_Click(tmpl.surveyTemplateId)">查看详情</button>
                            <button class="btn btn-success btn-sm" v-if="tmpl.state===surveyTemplateState.V1_NON_PUBLISHED"
                                    @click="btnUpdateSurveyTemplateState_Click(tmpl.surveyTemplateId, surveyTemplateState.V2_PUBLISHED, '确定发布此模板？')">发布</button>
                            <button class="btn btn-danger btn-sm" v-if="tmpl.state===surveyTemplateState.V2_PUBLISHED"
                                    @click="btnUpdateSurveyTemplateState_Click(tmpl.surveyTemplateId, surveyTemplateState.V3_DISABLED, '确定禁用此模板？')">禁用</button>
                            <button class="btn btn-success btn-sm" v-if="tmpl.state===surveyTemplateState.V3_DISABLED"
                                    @click="btnUpdateSurveyTemplateState_Click(tmpl.surveyTemplateId, surveyTemplateState.V2_PUBLISHED, '确定重新启用此模板？')">启用</button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <button class="btn btn-primary" @click="btnAddSurveyTemplateInfo_Click">添加反馈模板</button>
            </div>
        </div>

        <b-modal v-model="isEditEvaluateInfoDialogOpen"
                 :title="isInsertSurveyTemplateInfo? '添加反馈模板': '编辑反馈模板'"
                 ok-title="确定" cancel-title="取消" @ok="editSurveyTemplateInfoDialog_OK"
                 :no-close-on-backdrop="true">

            <div>
                <div class="form-group row">
                    <label for="inputSurveyTemplateName" class="col-sm-3 col-form-label text-right">模板名称</label>
                    <div class="col-sm-8">
                        <input type="text" class="form-control" id="inputSurveyTemplateName" placeholder="模板名称"
                               v-model="editSurveyTemplateInfo.surveyTemplateName">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputSurveyTemplateType" class="col-sm-3 col-form-label text-right">模板类型</label>
                    <div class="col-sm-8">
                        <select class="form-control" id="inputSurveyTemplateType"
                                v-model="editSurveyTemplateInfo.surveyTemplateType">
                            <option v-for="code in surveyTemplateTypeEnum" :key="code.codeValue" :value="code.codeValue">{{code.codeContent}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label text-right">计算规则</label>
                    <label for="inputExcludeMaxCount" class="col-sm-4 col-form-label text-left">去掉几个最高分：</label>
                    <div class="col-sm-3">
                        <input type="number" class="form-control" id="inputExcludeMaxCount"
                               v-model.number="editSurveyTemplateInfo.excludeMaxCount">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputExcludeMinCount" class="col-sm-4 offset-3 col-form-label text-left">去掉几个最低分：</label>
                    <div class="col-sm-3">
                        <input type="number" class="form-control" id="inputExcludeMinCount"
                               v-model.number="editSurveyTemplateInfo.excludeMinCount">
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-8 offset-3 option-padding-top">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="inputAllowAllFullScore" v-model="editSurveyTemplateInfo.allowAllFullScore">
                            <label class="form-check-label" for="inputAllowAllFullScore">允许反馈打分为满分</label>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-8 offset-3 option-padding-top">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="inputRequiredLessThenMinScore" v-model="editSurveyTemplateInfo.requiredLessThenMinScore">
                            <label class="form-check-label" for="inputRequiredLessThenMinScore">低分反馈必须填写原因</label>
                        </div>
                    </div>
                </div>
                <div class="form-group row" v-if="editSurveyTemplateInfo.requiredLessThenMinScore">
                    <label for="inputMinScore" class="col-sm-4 offset-3 col-form-label text-left">低于满分的百分比：</label>
                    <div class="col-sm-3">
                        <input type="number" class="form-control" id="inputMinScore"
                               v-model.number="editSurveyTemplateInfo.minScore">
                    </div>
                </div>
            </div>

        </b-modal>

        <b-modal v-model="isSurveyTemplateInfoShowDialogOpen"
                 title="反馈模板详细信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <survey-template-view :survey-template-id="currentSurveyTemplateId"></survey-template-view>
        </b-modal>
    </div>
</template>

<script>
import dictionary from "@/utils/dictionary";
import baseApi from "@/utils/api/base";
import studyApi from "@/utils/api/study";
import SurveyTemplateView from "@/components/SurveyTemplateView";
export default {
    name: "AdminSurveyTemplateManage",
    components: {SurveyTemplateView},
    data: function () {
        return {
            surveyTemplateState: dictionary.surveyTemplateState,
            surveyTemplateTypeEnum: [],

            surveyTemplateData: [],

            editSurveyTemplateInfo: {
                surveyTemplateId: '',
                surveyTemplateName: '',
                surveyTemplateType: 1,
                excludeMaxCount: 0,
                excludeMinCount: 0,
                minScore: 70,
                requiredLessThenMinScore: false,
                allowAllFullScore: true
            },
            isInsertSurveyTemplateInfo: true,
            isEditEvaluateInfoDialogOpen: false,

            currentSurveyTemplateId: '',
            isSurveyTemplateInfoShowDialogOpen: false,
        };
    },
    mounted() {
        this.getSurveyTemplateTypeEnum();
        this.getSurveyTemplateData();
    },
    methods: {
        getSurveyTemplateTypeEnum() {
            baseApi.codeValue.getSurveyTemplateTypeEnum().then(res => {
                this.surveyTemplateTypeEnum = res.data;
            });
        },

        getSurveyTemplateData() {
            studyApi.survey.template.getSurveyTemplateData().then(res => {
                this.surveyTemplateData = res.data;
            });
        },

        btnAddSurveyTemplateInfo_Click() {
            this.editSurveyTemplateInfo = {
                surveyTemplateId: '',
                surveyTemplateName: '',
                surveyTemplateType: 1,
                excludeMaxCount: 0,
                excludeMinCount: 0,
                minScore: 70,
                requiredLessThenMinScore: false,
                allowAllFullScore: true
            };
            this.isInsertSurveyTemplateInfo = true;
            this.isEditEvaluateInfoDialogOpen = true;
        },
        btnEditSurveyTemplateInfo_Click(index) {
            let info = this.surveyTemplateData[index];
            this.editSurveyTemplateInfo = {
                surveyTemplateId: info.surveyTemplateId,
                surveyTemplateName: info.surveyTemplateName,
                surveyTemplateType: info.surveyTemplateType,
                excludeMaxCount: info.excludeMaxCount,
                excludeMinCount: info.excludeMinCount,
                minScore: info.minScore,
                requiredLessThenMinScore: info.requiredLessThenMinScore,
                allowAllFullScore: info.allowAllFullScore
            };
            this.isInsertSurveyTemplateInfo = false;
            this.isEditEvaluateInfoDialogOpen = true;
        },
        editSurveyTemplateInfoDialog_OK() {
            if (this.isInsertSurveyTemplateInfo) {
                studyApi.survey.template.insertSurveyTemplateInfo(this.editSurveyTemplateInfo).then(res => {
                    this.getSurveyTemplateData();
                });
            }
            else {
                studyApi.survey.template.updateSurveyTemplateInfo(this.editSurveyTemplateInfo).then(res => {
                    this.getSurveyTemplateData();
                });
            }
        },

        btnUpdateSurveyTemplateState_Click(surveyTemplateId, state, message) {
            if (confirm(message)) {
                let info = {surveyTemplateId, state};
                studyApi.survey.template.updateSurveyTemplateState(info).then(res => {
                    this.getSurveyTemplateData();
                });
            }
        },

        btnShowSurveyTemplateInfo_Click(surveyTemplateId) {
            this.currentSurveyTemplateId = surveyTemplateId;
            this.isSurveyTemplateInfoShowDialogOpen = true;
        },
    }
}
</script>

<style scoped>

</style>